module.exports = __webpack_public_path__ + "static/media/product.6e668777.svg";